import React from 'react';
import {
  makeStyles, Typography, Box, Button, IconButton,
} from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Link from 'components/shared/Link';

const useStyles = makeStyles((theme) => ({
  address: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  location: {
    lineHeight: theme.spacing(2.5),
    color: theme.palette.secondary.dark,
    display: 'flex',
    alignItems: 'flex-start',
  },
  margin: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: theme.palette.grey['300'],
    marginRight: theme.spacing(0.5),
    display: 'flex',
  },
  upper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  iconBtn: {
    marginTop: theme.spacing(-2),
  },
  btn: {
    marginTop: theme.spacing(-1),
  },
  note: {
    color: theme.palette.grey['300'],
    marginTop: theme.spacing(1),
  },
}));

const Address = ({
  location, note, linkText, linkHref,
}) => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.address}>
        <Box className={classes.icon}>
          <LocationOnIcon />
        </Box>

        <Box flexGrow="1">
          {location && (
          <Box className={classes.upper}>
            <Typography className={`${classes.location} ${linkText ? classes.margin : ''}`} varaint="body1">
              {location}

              {(!linkText && linkHref) && (
              <IconButton
                component={Link}
                target="_blank"
                href={linkHref}
                color="primary"
                className={classes.iconBtn}
              >
                <OpenInNewIcon />
              </IconButton>
              )}
            </Typography>

            {linkText && (
              <Button
                color="primary"
                className={classes.btn}
                endIcon={<OpenInNewIcon />}
                component={Link}
                href={linkHref}
                target="_blank"
              >
                {linkText}
              </Button>
            )}
          </Box>
          )}

          {note && (
          <Typography className={classes.note} variant="body2">
            {note}
          </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Address;
